import { render, staticRenderFns } from "./overseaForm.vue?vue&type=template&id=5a0adbe1&scoped=true&"
import script from "./overseaForm.vue?vue&type=script&lang=js&"
export * from "./overseaForm.vue?vue&type=script&lang=js&"
import style0 from "./overseaForm.vue?vue&type=style&index=0&id=5a0adbe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0adbe1",
  null
  
)

component.options.__file = "overseaForm.vue"
export default component.exports